export default "__VITE_ASSET__C3D8ZSRd__"